import { ThemeDefinition } from 'vuetify/framework';
import { addStatusColors } from './vuetify-theme-shared';

export const naiveLight: ThemeDefinition = addStatusColors({
    dark: false,
    colors: {
        // Role colors - adjusted for better contrast on light backgrounds
        primary: '#0d9668',
        secondary: '#64748b',
        info: '#0284c7',
        success: '#0d9668',
        warning: '#f2c97d',
        error: '#dc2626',

        // Surfaces - subtle off-white for glass effect base
        background: '#f8f9fc',
        surface: '#ffffff',
        'surface-variant': '#e8e8ec',
        'on-background': '#1e293b',
        'on-surface': '#1e293b',
        'on-surface-variant': '#1e293b',
    },
    variables: {
        // --- primary (teal-green)
        'naive-primary-hover': '#10b981',
        'naive-primary-default': '#0d9668',
        'naive-primary-active': '#047857',
        'naive-primary-suppl': '#10b981',
        // --- info (sky blue)
        'naive-info-hover': '#0ea5e9',
        'naive-info-default': '#0284c7',
        'naive-info-active': '#0369a1',
        'naive-info-suppl': '#0ea5e9',
        // --- error (red)
        'naive-error-hover': '#ef4444',
        'naive-error-default': '#dc2626',
        'naive-error-active': '#b91c1c',
        'naive-error-suppl': '#ef4444',
        // --- warning (amber)
        'naive-warning-hover': '#f59e0b',
        'naive-warning-default': '#d97706',
        'naive-warning-active': '#b45309',
        'naive-warning-suppl': '#f59e0b',
        // --- success (same as primary)
        'naive-success-hover': '#10b981',
        'naive-success-default': '#0d9668',
        'naive-success-active': '#047857',
        'naive-success-suppl': '#10b981',
    },
});
